var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUdhaarCheckoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFF7E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 62.5C35.2554 62.5 34.3016 62.8951 33.5983 63.5983C32.8951 64.3016 32.5 65.2554 32.5 66.25C32.5 67.6307 31.3807 68.75 30 68.75C28.6193 68.75 27.5 67.6307 27.5 66.25C27.5 63.9294 28.4219 61.7038 30.0628 60.0628C31.7038 58.4219 33.9294 57.5 36.25 57.5H67.5C68.8807 57.5 70 58.6193 70 60C70 61.3807 68.8807 62.5 67.5 62.5H36.25Z",
    fill: "#FDB022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 30C35.2554 30 34.3016 30.3951 33.5983 31.0983C32.8951 31.8016 32.5 32.7554 32.5 33.75V66.25C32.5 67.2446 32.8951 68.1984 33.5983 68.9016C34.3016 69.6049 35.2554 70 36.25 70H65V30H36.25ZM30.0628 27.5628C31.7038 25.9219 33.9294 25 36.25 25L67.5 25C68.8807 25 70 26.1193 70 27.5V72.5C70 73.8807 68.8807 75 67.5 75H36.25C33.9294 75 31.7038 74.0781 30.0628 72.4372C28.4219 70.7962 27.5 68.5706 27.5 66.25L27.5 33.75C27.5 31.4294 28.4219 29.2038 30.0628 27.5628Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdhaarCheckoutIcon);
export default __webpack_public_path__ + "static/media/udhaarCheckoutIcon.a9b60b8b52f34079b76026e1bb0b8109.svg";
export { ForwardRef as ReactComponent };